import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=737aa8ec&scoped=true&"
import script from "./SearchWidget.vue?vue&type=script&lang=js&"
export * from "./SearchWidget.vue?vue&type=script&lang=js&"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=737aa8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737aa8ec",
  null
  
)

export default component.exports